import "core-js/modules/web.timers.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
import { useEffect, useState, useRef } from 'react';
import { unstable_batchedUpdates } from 'react-dom';
function useDebouncedState(
// eslint-disable-line @typescript-eslint/no-explicit-any
defaultState) {
  var delayOrOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 200;
  var delay = typeof delayOrOptions === 'number' ? delayOrOptions : (delayOrOptions === null || delayOrOptions === void 0 ? void 0 : delayOrOptions.delay) || 200;
  var onChangeRef = useRef(_typeof(delayOrOptions) === 'object' && (delayOrOptions === null || delayOrOptions === void 0 ? void 0 : delayOrOptions.onChange));
  onChangeRef.current = _typeof(delayOrOptions) === 'object' && (delayOrOptions === null || delayOrOptions === void 0 ? void 0 : delayOrOptions.onChange);
  var _useState = useState(defaultState),
    _useState2 = _slicedToArray(_useState, 2),
    value = _useState2[0],
    setValue = _useState2[1];
  var _useState3 = useState(defaultState),
    _useState4 = _slicedToArray(_useState3, 2),
    debouncedValue = _useState4[0],
    setDebouncedValue = _useState4[1];
  useEffect(function () {
    var timeoutId = setTimeout(function () {
      // Even though this function is prefixed with "unstable" the react
      // team has recommended using it where appropriate.  See:
      // https://github.com/facebook/react/issues/16387#issuecomment-521623662
      unstable_batchedUpdates(function () {
        setDebouncedValue(value);
        if (typeof onChangeRef.current === 'function') {
          onChangeRef.current();
        }
      });
    }, delay);
    return function () {
      return clearTimeout(timeoutId);
    };
  }, [value]);
  return [value, debouncedValue, setValue];
}
export default useDebouncedState;